import { render, staticRenderFns } from "./dashboard_list.vue?vue&type=template&id=613a8ce4&scoped=true"
import script from "./dashboard_list.vue?vue&type=script&lang=js"
export * from "./dashboard_list.vue?vue&type=script&lang=js"
import style0 from "./dashboard_list.vue?vue&type=style&index=0&id=613a8ce4&prod&scoped=true&lang=css"
import style1 from "./dashboard_list.vue?vue&type=style&index=1&id=613a8ce4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a8ce4",
  null
  
)

export default component.exports